import { Product } from '@df/catalog/product/product';
import { NgInject } from '@df/ng/ng-inject';
import { App } from '@df/core/app';
import difference from 'lodash-es/difference';
import intersection from 'lodash-es/intersection';
import { IListingSortEngine, IListingSortOption, ListingSort } from './listing-sort';
import { Listing } from '../listing';

declare module '@df/session/customer/customer.interfaces' {
    namespace Customer {
        interface ICustomerData {
            favourites?: number[];
        }
    }
}

export class ListingSortFavouritesEngine implements IListingSortEngine<Product> {
    @NgInject(App)
    app!: App;

    public sort(collection: Product[], option: IListingSortOption, listing: Listing<Product>, cb: (models: Product[]) => void): void {
        this.app.customer.model.load().then(customerModel => {
            if (customerModel.data.favourites) {
                const favourites_products: Product[] = this.app.resources.product.getAllExisting(customerModel.data.favourites);
                cb([...intersection(favourites_products, collection), ...difference(collection, favourites_products)]);
            } else {
                cb(collection);
            }
        });
    }
}

ListingSort.engines['favourites'] = new ListingSortFavouritesEngine();
